import { graphql } from 'src/graphql';

export const PaymentOverdueBanner = graphql(`
  query PaymentOverdueBanner($teamId: ID!) {
    transactionsByTeam(_team_id: $teamId, types: [1]) {
      _id
      status
      created
      invoice {
        amount_due
      }
    }
  }
`);
